import React, { useState, useEffect } from 'react'
import { message, Pagination, Spin } from 'antd'
import { getListGroupBatch } from '../../../services/api/3dApi'
import moment from "moment"
import { NavLink } from 'react-router-dom'
import UseDebounce from '../../users/helpers/UseDebounce'
import GroupBatchFilter from './filter/GroupBatchFilter'
import GroupBatchTable from './table/GroupBatchTable'

const ListGroupBatchPage = () => {
    const [listBatches, setListBatches] = useState([])
    const [name, setName] = useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [userCreate, setUserCreate] = useState([])
    const [created, setCreated] = useState("")
    const [listUser, setListUser] = useState([])

    const debounceName = name === '' ? UseDebounce(name, 0) : UseDebounce(name, 500)

    const _handleChangeDate = filter => {
        const { created_at } = Object.assign({}, filter)
        setCreated({ ...created_at })
        setPage(1)
    }

    const _handleChangeUsers = value => {
        setUserCreate(value)
        setPage(1)
    }

    const _handleChangeInput = (field, value) => {
        if (field === 'user_create') setUserCreate(value)
        if (field === 'name') setName(value)
        setPage(1)
    }

    const _handlePageChange = page => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const _fetchGroupBatch = async () => {
        setLoading(true)
        try {
            const payload = {
                page, limit
            }

            if (!!debounceName) payload.batch_names = debounceName.trim().split(/[\s,]+/)
            if (!!userCreate.length) payload.created_by = userCreate
            if (!!created.from && !!created.to) {
                payload.created_at = {
                    from: created.from,
                    to: created.to
                }
            }

            const { data: res = {} } = await getListGroupBatch(payload)
            const { data, success, message: mess } = res
            if (!success) throw new Error(mess)

            const { items = [], total, users = [] } = data
            setListBatches(items)
            setTotal(total)
            setListUser(users)

        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        _fetchGroupBatch()
    }, [page, limit, debounceName, userCreate, created])

    return (
        <div className='ListGroupBatchPage'>
            <div className="container-fluid min-vh-100">
                <div className="col-12 mx-auto bg-white shadow-sm py-3 px-0 px-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className="m-0">Quản lý nhóm lô</h3>
                        </div>
                    </div>

                    <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                        <GroupBatchFilter
                            created={created}
                            userCreate={userCreate}
                            handleChangeInput={_handleChangeInput}
                            handleChangeDate={_handleChangeDate}
                            onChangeUserCreated={_handleChangeUsers}
                            listUser={listUser}
                        />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && (
                                <div className="text-danger mb-2">{error}</div>
                            )}
                        </div>
                        <Pagination current={page} total={total} pageSize={limit}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={_handlePageChange}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={_handleShowSizeChange} />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <GroupBatchTable
                            data={listBatches}
                            reload={_fetchGroupBatch}
                        />
                    </Spin>

                    <Pagination
                        current={page} total={total} pageSize={limit}
                        onChange={_handlePageChange}
                        showQuickJumper
                        className='CustomPagination text-right' showSizeChanger
                        pageSizeOptions={['10', '20', '50', '100']}
                        onShowSizeChange={_handleShowSizeChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListGroupBatchPage